import { Link } from 'gatsby';
import { EuiSpacer } from '@elastic/eui';
import PrimaryBox from 'components/Quick_Installation/WebUI_And_Firmware_Upgrade/VGA_Cameras/PrimaryBox';
import DangerBox from 'components/Quick_Installation/WebUI_And_Firmware_Upgrade/VGA_Cameras/DangerBox';
import NavButtons from 'components/Quick_Installation/WebUI_And_Firmware_Upgrade/NavButtons';
import ForumBox from 'components/Quick_Installation/WebUI_And_Firmware_Upgrade/ForumBox';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  Link,
  EuiSpacer,
  PrimaryBox,
  DangerBox,
  NavButtons,
  ForumBox,
  BreadCrumbs,
  SEOHelmet,
  React
};